import { render } from "./Admissions.vue?vue&type=template&id=5cd866ba&scoped=true"
import script from "./Admissions.vue?vue&type=script&lang=js"
export * from "./Admissions.vue?vue&type=script&lang=js"

import "./Admissions.vue?vue&type=style&index=0&id=5cd866ba&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cd866ba"]])

export default __exports__